import { BaseLayerElement } from './layer.js';

export class LayerDashElement extends BaseLayerElement {
  constructor() {
    super();
    // specific behavior for <map-layer>
  }
}
